<template>
  <el-dialog
    :title="$t('ProjectSettings_ChannelSettingsTab_ConfirmTitle')"
    :modal="true"
    :modal-append-to-body="false"
    :visible.sync="display"
    width="40%"
    center
  >
    <p class="description">
      {{ description }}
    </p>
    <span slot="footer" class="dialog-footer">
      <el-button
        v-if="$can('XpEmailConfiguration:FullAccess')"
        type="primary"
        plain
        @click="skip"
      >
        {{ $t('ProjectSettings_ChannelSettingsTab_Button_VerifyImmediately') }}
      </el-button>
      <el-button v-else type="primary" plain @click="cancel">
        {{ $t('ProjectSettings_ChannelSettingsTab_ConfirmCancel') }}
      </el-button>
      <el-button
        type="primary"
        @click="emailVerificationRequest"
        :loading="loading"
      >
        {{ confirmButtonLabel }}
      </el-button>
    </span>
  </el-dialog>
</template>

<script>
import RestApi from '@/core/services/RestApi'
import { projectEndpoint } from '@/core/helpers'
import { emailVerificationEnum } from '@/modules/settings/enum/EmailVerificationEnum'

export default {
  name: 'EmailVerificationPopup',
  data() {
    return {
      loading: false,
      display: false
    }
  },
  methods: {
    show() {
      this.display = true
    },
    hide() {
      this.display = false
    },
    skip() {
      this.hide()
      this.$emit('verification-status', emailVerificationEnum.VERIFIED)
    },
    cancel() {
      this.hide()
      this.$emit('verification-refusal')
    },
    emailVerificationRequest() {
      this.loading = true
      RestApi(
        projectEndpoint({
          method: 'post',
          url: `email-request`
        })
      )
        .then(() => {
          this.hide()
          this.$emit('verification-status', emailVerificationEnum.SENT)
        })
        .catch(error => {
          this.$emit('verification-refusal', false)
          this.hide()
          this.$message({
            message: error.message,
            type: 'error'
          })
        })
        .finally(() => {
          this.loading = false
        })
    }
  },
  computed: {
    description() {
      if (this.$can('XpEmailConfiguration:FullAccess')) {
        return this.$t('ProjectSettings_ChannelSettingsTab_ConfirmMessageAdmin')
      }
      return this.$t('ProjectSettings_ChannelSettingsTab_ConfirmMessage')
    },
    confirmButtonLabel() {
      if (this.$can('XpEmailConfiguration:FullAccess')) {
        return this.$t(
          'ProjectSettings_ChannelSettingsTab_Button_AwaitingSetup'
        )
      }
      return this.$t('ProjectSettings_ChannelSettingsTab_ConfirmYes')
    }
  }
}
</script>

<style scoped lang="scss">
.description {
  text-align: center;
  word-break: break-word;
}
</style>



// WEBPACK FOOTER //
// src/modules/settings/components/EmailVerificationPopup.vue